module.exports = __webpack_public_path__ + "static/media/location-maps-letter-i-arrow-serr2.a362672c.png";